import React from 'react';
import { Card, CardHeader, CardMedia, CardContent, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';

const styles = {
  card: {
    maxWidth: 600,
    margin: '50px auto',
    paddingTop: '46px',
    height: '150px'
  },
  cardHeader: {
    color: 'white'
  },
  cardTitle: {
    fontSize: 24,
    fontWeight: 500
  },
  cardSubtitle: {
    fontSize: 18,
    fontWeight: 400,
    color: grey[900]
  },
  cardText: {
    fontSize: 16,
    fontWeight: 400,
    color: grey[900],
    fontFamily: 'Open Sans',
    lineSpacing: '-0.5px'
  },
};

const Unauthorized = () => (
  // <Card style={styles.card}>
  //   <CardHeader/>
  //   <CardMedia
  //   overlay={<CardTitle title="Access Denied" subtitle="You are not authorized for this page." />}
  //   >
  //   </CardMedia >
  //   <CardText style={styles.cardText}>
  //     Please contact the administrator if you believe this is an error.
  //   </CardText>
  // </Card>

  <Card style={styles.card}>
    <CardHeader />

    {/* Media Section */}
    <div style={{ position: 'relative' }}>
      <CardMedia
        component="img"
        height=""
        image=""
        alt="Access Denied"
      />

      {/* Overlay for Title */}
      <div style={styles.mediaOverlay}>
        <Typography variant="h5">Access Denied</Typography>
        <Typography variant="subtitle1">You are not authorized for this page.</Typography>
      </div>
    </div>

    {/* Text Section */}
    <CardContent>
      <Typography variant="body2" color="textSecondary" style={styles.cardText}>
        Please contact the administrator if you believe this is an error.
      </Typography>
    </CardContent>
  </Card>
);

export default Unauthorized;
